/**
 * 
 * @param {Array<Object<string, any>>} arr array to be filtered
 * @param {string} prop property name that values will be compared on
 */
export function duplicateValuesByProp(arr, prop) {
    if(!Array.isArray(arr) || typeof arr[0] !== 'object') {
        throw new Error('First argument should be an array of objects');
    }

    return [
        ...new Map(
            arr.map(item => {
                return [ item[prop], item ];
            })
        ).values()
    ];
}
